export class PatientModel {
  patientCode = ''
  patientFName = ''
  diagnosis = ''
  patientLName = ''
  patientFullName = ''
  birthDate = ''
  education = ''
  nationality = ''
  occupation = ''
  referredFrom = ''
  telHome = ''
  telBusin = ''
  telMobile = ''
  addressHome = ''
  addressBusin = ''
  email = ''
  relativeName = ''
  relativeTelHome = ''
  relativeTelBusin = ''
  relativeTelMobile = ''
  relativeAddressHome = ''
  relativeAddressBusin = ''
  userDef1 = ''
  userDef2 = ''
  userDefDate = ''
  userDefNum = ''
  dateEntry = ''
  gender = ''
  marital = ''
  noChildren = ''
  ageOldest = ''
  ageYoungest = ''
  status = ''
  cancerID = ''
  docCode = ''
  txtRef = ''
  pathology = ''
  menstrual = ''
  since = ''
  contraception = ''
  pregnancy = ''
  smoker = ''
  smokerType = ''
  noPacks = ''
  sSince = 0
  mSince = ''
  drinkingAlcohol = ''
  deteRelapse = ''
  ageYear='0';
  gov = '';
  compCode = '';
  userID = '';
  modifiedDate = '';
  resid='0';
}
